var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobConvoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "#FFEDD5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10527_25868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 9.99967C16.6673 8.74234 16.6673 8.11434 16.2767 7.72367C15.886 7.33301 15.258 7.33301 14.0007 7.33301C12.7433 7.33301 12.1153 7.33301 11.7247 7.72367C11.334 8.11434 11.334 8.74234 11.334 9.99967M7.33398 15.333C7.33398 12.819 7.33398 11.5617 8.11532 10.781C8.89665 10.0003 10.1533 9.99967 12.6673 9.99967H15.334C17.848 9.99967 19.1053 9.99967 19.886 10.781C20.6666 11.5623 20.6673 12.819 20.6673 15.333C20.6673 17.847 20.6673 19.1043 19.886 19.885C19.1046 20.6657 17.848 20.6663 15.334 20.6663H12.6673C10.1533 20.6663 8.89598 20.6663 8.11532 19.885C7.33465 19.1037 7.33398 17.847 7.33398 15.333Z",
    stroke: "#F97316",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3346 11.9997C17.3346 12.1765 17.2644 12.3461 17.1394 12.4711C17.0143 12.5961 16.8448 12.6663 16.668 12.6663C16.4912 12.6663 16.3216 12.5961 16.1966 12.4711C16.0715 12.3461 16.0013 12.1765 16.0013 11.9997C16.0013 11.8229 16.0715 11.6533 16.1966 11.5283C16.3216 11.4032 16.4912 11.333 16.668 11.333C16.8448 11.333 17.0143 11.4032 17.1394 11.5283C17.2644 11.6533 17.3346 11.8229 17.3346 11.9997ZM12.0013 11.9997C12.0013 12.1765 11.9311 12.3461 11.806 12.4711C11.681 12.5961 11.5114 12.6663 11.3346 12.6663C11.1578 12.6663 10.9883 12.5961 10.8632 12.4711C10.7382 12.3461 10.668 12.1765 10.668 11.9997C10.668 11.8229 10.7382 11.6533 10.8632 11.5283C10.9883 11.4032 11.1578 11.333 11.3346 11.333C11.5114 11.333 11.681 11.4032 11.806 11.5283C11.9311 11.6533 12.0013 11.8229 12.0013 11.9997Z",
    fill: "#F97316"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10527_25868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobConvoIcon);
export default __webpack_public_path__ + "static/media/job-convo-icon.cf7cd3d33f281b6808ddedb62999be64.svg";
export { ForwardRef as ReactComponent };